import { connect } from 'react-redux';
import { useState, useEffect } from 'react';
import { fetchServiceDetails } from '../../store/app/apis';
import { getTime } from '../../utils';
import { SERVICE_STATUS } from '../../constants';
import styles from './Servicedetails.module.css';
import { useParams } from 'react-router-dom';
import Action from '../Actions/action';
import AddBoxIcon from '@mui/icons-material/AddBox';

function ServiceDetails({ serviceList, fetchServiceDetails }) {
  const [service, setService] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const params = useParams();

  useEffect(() => {
    const id = params.id;
    if (serviceList?.length !== 0 && serviceList?.find((service) => service.id === id))
      setService(serviceList?.find((service) => service.id === id));
    else
      fetchServiceDetails(id).then((res) => {
        setService(res);
      });
  }, [serviceList, params.id]);
  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  return (
    <div>
      <div className={styles.addaction}>
        <button className={styles.action} onClick={handleClick}>
          <AddBoxIcon />
          Action
        </button>
      </div>
      <div className={styles.alerts}>
        <div className={styles.leftDiv}>
          {service?.name && (
            <div className={styles.commonright}>
              <label>Service Name:</label>
              <span>{service?.name}</span>
            </div>
          )}
          {service?.ip && (
            <div className={styles.commonright}>
              <label>IP</label>
              <span>{service?.ip}</span>
            </div>
          )}
          {service?.env && (
            <div className={styles.commonright}>
              <label>Environment</label>
              <span>{service?.env}</span>
            </div>
          )}
          {service?.ct && (
            <div className={styles.commonright}>
              <label>Created Time</label>
              <span>{getTime(service?.ct)}</span>
            </div>
          )}

          <div className={styles.commonright}>
            <label>Modified Time</label>
            <span>{!service?.mt || service?.mt === 0 ? 'NOT MODIFIED' : getTime(service.mt)}</span>
          </div>
          {service?.version && (
            <div className={styles.commonright}>
              <label>Version</label>
              <span>{service?.version}</span>
            </div>
          )}
          {service?.user && (
            <div className={styles.commonright}>
              <label>User</label>
              <span>{service?.user}</span>
            </div>
          )}
          {service?.deploy !== 0 && (
            <div className={styles.commonright}>
              <label>Deploy</label>
              <span>{getTime(service?.deploy)}</span>
            </div>
          )}
          {(service?.status === 0 || service?.status) && (
            <div className={styles.commonright}>
              <label>Status</label>
              <span>
                {service?.status === SERVICE_STATUS.SERVICE_UP
                  ? 'SERVICE UP'
                  : service?.status === SERVICE_STATUS.SERVICE_CREATED
                  ? 'SERVICE CREATED'
                  : 'SERVICE DOWN'}
              </span>
            </div>
          )}
        </div>
        {service?.stype === 'es' && (
          <div className={styles.rightDiv}>
            {service?.elastic && (
              <div className={styles.commonright}>
                <label>Elastic Active Primary Shards</label>
                <span>{service?.elastic?.active_primary_shards}</span>
              </div>
            )}
            {service?.elastic && (
              <div className={styles.commonright}>
                <label>Elastic Active Shards</label>
                <span>{service?.elastic?.active_shards}</span>
              </div>
            )}
            {service?.elastic && (
              <div className={styles.commonright}>
                <label>Cluster Name</label>
                <span>{service?.elastic?.cluster_name}</span>
              </div>
            )}
            {service?.elastic && (
              <div className={styles.commonright}>
                <label>Elastic indexhealth Red</label>
                <span>{service?.elastic?.idxhealth?.red}</span>
              </div>
            )}
            {service?.elastic && (
              <div className={styles.commonright}>
                <label>Elastic indexhealth Green</label>
                <span>{service?.elastic?.idxhealth?.green}</span>
              </div>
            )}
            {service?.elastic && (
              <div className={styles.commonright}>
                <label>Elastic indexhealth Yellow</label>
                <span>{service?.elastic?.idxhealth?.yellow}</span>
              </div>
            )}

            {service?.elastic && (
              <div className={styles.commonright}>
                <label>Initialized Shards</label>
                <span>{service?.elastic?.initialized_shards}</span>
              </div>
            )}
            {service?.elastic && (
              <div className={styles.commonright}>
                <label>Number Of Data Nodes</label>
                <span>{service?.elastic?.number_of_data_nodes}</span>
              </div>
            )}
            {service?.elastic && (
              <div className={styles.commonright}>
                <label>Number of Nodes</label>
                <span>{service?.elastic?.number_of_nodes}</span>
              </div>
            )}
            {service?.elastic && (
              <div className={styles.commonright}>
                <label>Relocating Shards</label>
                <span>{service?.elastic?.relocating_shards}</span>
              </div>
            )}
            {service?.elastic && (
              <div className={styles.commonright}>
                <label>Status</label>
                <span>{service?.elastic?.status}</span>
              </div>
            )}
            {service?.elastic && (
              <div className={styles.commonright}>
                <label>Time Out</label>
                <span>{service?.elastic?.timed_out}</span>
              </div>
            )}
            {service?.elastic && (
              <div className={styles.commonright}>
                <label>Unassigned Shards</label>
                <span>{service?.elastic?.unassigned_shards}</span>
              </div>
            )}
          </div>
        )}
        {anchorEl && <Action anchorEl={anchorEl} onClose={handleClick} id={params.id} />}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    serviceList: state.app.serviceList,
  };
};
const mapDispatchToProps = { fetchServiceDetails };

export default connect(mapStateToProps, mapDispatchToProps)(ServiceDetails);
